import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ClipboardList, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { PageShell } from "@/components/AppShell";
import { Loader } from "@/components/ProtectedRoute";
import { Md } from "@/components/LessonBlocks";
import { t } from "@/lib/i18n";

const tx = (k, en) => (t(k) === k ? en : t(k));

export default function PlantProject() {
  const { data } = useQuery({ queryKey: ["plant-project"], queryFn: async () => (await api.get("/project")).data, staleTime: 0 });
  if (!data) return <Loader />;
  return (
    <PageShell>
      <div className="overline-label">My path</div>
      <h1 data-testid="project-title" className="mt-2 flex items-center gap-3 font-heading text-3xl font-black tracking-tight sm:text-4xl"><ClipboardList className="h-8 w-8 text-brand-accent" />{t("Your plant project")}</h1>
      <p className="mt-3 max-w-2xl text-muted-foreground">{tx("project-intro", "Each lesson ends with one step for your own plant. The steps add up to your opportunity canvas and your pilot brief.")}</p>
      <p data-testid="project-count" className="mt-2 text-sm font-semibold">{data.steps.length} of {data.total} steps done</p>
      {data.steps.length === 0 ? (
        <div data-testid="project-empty" className="mt-8 rounded-lg border border-dashed border-border p-8 text-center text-muted-foreground">
          Finish your first lesson to add step 1. <Link to="/learn" className="font-semibold text-brand-primary underline">Go to Learn</Link>
        </div>
      ) : (
        <ol className="mt-8 space-y-4">
          {data.steps.map((s) => (
            <li key={s.lesson_id} data-testid={`project-step-${s.lesson_id}`} className="rounded-r-lg border-l-4 border-brand-accent bg-card p-5">
              <Link to={`/lessons/${s.lesson_id}`} className="inline-flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-brand-primary">{s.module_id} · {s.title}<ArrowRight className="h-3.5 w-3.5" /></Link>
              <div className="reader simple-reader mt-2"><Md>{s.project}</Md></div>
            </li>
          ))}
        </ol>
      )}
    </PageShell>
  );
}
